import { useAtomValue } from 'jotai';

import { useObscuredContentProps } from '../../a11y';
import { visitorDrawerStateAtom } from '../state';

/**
 * See `useObscuredContentProps` for more information.
 */
export function useObscuredVisitorContentProps() {
  const isDrawerOpen = !!useAtomValue(visitorDrawerStateAtom);

  return useObscuredContentProps({ isDrawerOpen });
}
